import ApiService from '@shared/services/api.service';

const AccountService = {
  getUser() {
    return ApiService.get('/user');
  },
  getUserInRole() {
    return ApiService.get('/impersonated_user');
  },
  switchRoleUser(user) {
    return ApiService.post('/user/login_impersonated/' + user, null);
  },
  getSwitchUser() {
    return ApiService.get('/user/switch_user');
  },
  updateUser(bodyParams) {
    return ApiService.put('/user', bodyParams);
  },
  updateUserInRole(bodyParams) {
    return ApiService.put('/impersonated_user', bodyParams);
  },
  changePassword(bodyParams) {
    return ApiService.post('/user/change_password', bodyParams);
  },
  get2FASecret() {
    return ApiService.get('/user/request_2fa_secret');
  },
  activate2FA(bodyParams) {
    return ApiService.post('/user/activate_2fa', bodyParams);
  },
  deactivate2FA(bodyParams) {
    return ApiService.post('/user/deactivate_2fa', bodyParams);
  },
  createApiKey(token_name){
    return ApiService.post('/impersonated_user/api_key/', {"token_name": token_name});
  },
  fetchApiKeyList(){
    return ApiService.get('/impersonated_user/api_key');
  },
  deleteApiKey(token_name){
    token_name = encodeURIComponent(token_name);
    return ApiService.delete(`/impersonated_user/api_key/${token_name}`);
  },
  updateApiKeyStatus(token_name, bodyParams){
    token_name = encodeURIComponent(token_name);
    return ApiService.put(`/impersonated_user/api_key/${token_name}`, bodyParams);
  }
};
export default AccountService;
